export const AuthI18N = {
  en: {
    "auth.connect": "Connect",
    "sso.select_org": "Choose the organization you want to access",
    "auth.authentication": "Authentication",
    "auth.coming_soon": "Coming soon",
    "auth.required": "Required",
    "auth.invalid_email": "Invalid email",
    back: "Back",
    beta_version: "BETA",
    terms_privacy: {
      processing_agree_tuvis: "By processing you agree to Tuvis",
      terms_of_service: "Terms of Service",
      and: "and",
      privacy_policy: "Privacy policy",
    },
    use_custom_domain: "Use sandbox or custom domain",
    click_here: "Click Here",
    login_page: {
      need_user_name: "Need to enter your Salesforce username?",
      no_user_name: "Log in without a username",
    },
  },
  es: {
    "auth.connect": "Conectar",
    "sso.select_org": "Elige la organización a la que deseas acceder",
    "auth.authentication": "Autenticación",
    "auth.coming_soon": "Próximamente",
    "auth.required": "Requerido",
    "auth.invalid_email": "Email inválida",
    back: "Atrás",
    beta_version: "BETA",
    terms_privacy: {
      processing_agree_tuvis: "By processing you agree to Tuvis",
      terms_of_service: "Terms of Service",
      and: "and",
      privacy_policy: "Privacy policy",
    },
    use_custom_domain: "¿Usar sandbox o dominio personalizado",
    click_here: "Haga Clic Aquí",
    login_page: {
      need_user_name: "¿Necesita ingresar su nombre de usuario de Salesforce?",
      no_user_name: "Iniciar sesión sin usuario",
    },
  },
  pt: {
    "auth.connect": "Conectar",
    "sso.select_org": "Escolha a organização que você deseja acessar",
    "auth.authentication": "Autenticação",
    "auth.coming_soon": "Em breve",
    "auth.required": "Obrigatório",
    "auth.invalid_email": "Email inválida",
    back: "Voltar",
    beta_version: "BETA",
    terms_privacy: {
      processing_agree_tuvis: "By processing you agree to Tuvis",
      terms_of_service: "Terms of Service",
      and: "and",
      privacy_policy: "Privacy policy",
    },
    use_custom_domain: "Use sandbox ou domínio personalizado",
    click_here: "Clique Aqui",
    login_page: {
      need_user_name: "Precisa inserir seu nome de usuário do Salesforce?",
      no_user_name: "Faça login sem um nome de usuário",
    },
  },
};
